<script>
    import {Line, mixins} from 'vue-chartjs'
    import {mapGetters} from 'vuex'

    export default {
        extends: Line,
        mixins: [mixins.reactiveProp],
        props: ['chartData'],
        data() {
            return {}
        },
        computed: {
            ...mapGetters(['getBatch']),
            getOptions(variableOptions) {
                var batchSize = Math.round(parseInt(this.getBatch.batchSize) * 0.8)
                return {
                    // cutoutPercentage: 75,
                    title: {
                        display: false,
                    },
                    elements: {
                        point: {
                            radius: 0
                        },
                    },
                    // spanGaps: true,
                    scales: {
                        yAxes: [
                            {
                                display: false,
                                id: "2",
                                stacked: true,
                                position: 'left',
                                autoSkip: true,
                                beginAtZero: true,
                                gridLines: {
                                    display: false,
                                    color: '#1e1e2f',
                                    drawBorder: false,
                                    zeroLineColor: '#1e1e2f',
                                },
                                ticks: {
                                    beginAtZero: true,
                                    min: 0,
                                    max: 100,
                                    // max: batchSize
                                },
                                scaleLabel: {
                                    display: false,
                                    fontSize: 20
                                },
                            },

                        ],
                        xAxes: [
                            {
                                beginAtZero: true,
                                autoSkip: true,
                                display: false,
                                gridLines: {
                                    display: false,
                                    color: '#1e1e2f',
                                    zeroLineColor: '#1e1e2f',
                                },
                                ticks: {
                                    beginAtZero: true,
                                    fontColor: '#ffffff',
                                }
                            }]
                    },
                    legend: {
                        display: true,
                    },
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: 0 // general animation time
                    },
                    hover: {
                        animationDuration: 0 // duration of animations when hovering an item
                    },
                    responsiveAnimationDuration: 0 // animation duration after a resize
                }
            }
        },
        methods: {
            renderThatChart() {
                this.renderChart(
                    this.chartData
                    , this.getOptions)
            }
        },

        mounted() {
            this.renderThatChart()


        }
    }
</script>

<style>
</style>